import { CONTACT_API } from 'modules/contacts/api/contact-api'
import { ContactsImportColumnsSelectOptionsApi } from 'modules/contacts/contacts-import/types/contacts-import-column-select'
import { useMemo } from 'react'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useContactsImportColumnsSelectOptions() {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactsImportColumnsSelectOptionsApi>({
    method: RequestMethodsEnum.get,
  })

  const { data, mutate: mutateContactsImportColumnsSelectOptions } = useSWR(() => {
    if (user) {
      return `${CONTACT_API}/contacts/import/columns`
    } else {
      return null
    }
  }, fetcher)

  const contactsImportColumnsSelectOptions = useMemo(
    () =>
      data
        ? [
            { id: null, caption: '—' },
            ...Object.entries(data).map(([id, caption]) => ({ id, caption })),
          ]
        : undefined,
    [data],
  )

  return { contactsImportColumnsSelectOptions, mutateContactsImportColumnsSelectOptions }
}
